import React, { useCallback } from 'react';
import { useParams } from 'react-router';

import { deleteSurgeryHistory, getSurgeryHistory, saveSurgeryHistory, updateSurgeryHistory } from 'api/hs/examination';

import History from './History';
import { ListItem } from './History/history.context';

export default function SurgeryHistory() {
  const { employeeId, examinationId } = useParams<{ employeeId: string; examinationId: string }>();

  const fetch = useCallback(() => getSurgeryHistory(employeeId, examinationId), [employeeId, examinationId]);
  const save = useCallback(({ description }: Omit<ListItem, 'id'>) => saveSurgeryHistory({ employeeId, examinationId, description }), [
    employeeId,
    examinationId,
  ]);
  const update = useCallback(({ id, ...rest }: ListItem) => updateSurgeryHistory(id, rest), []);
  const remove = useCallback((id: ListItem['id']) => deleteSurgeryHistory(id), []);

  return <History fetch={fetch} save={save} update={update} remove={remove} title="Ameliyat" />;
}
